module.exports = __webpack_public_path__ + "store/img/DYOT-banner-tag5.c8a3bd41.gif";